import styled from "@emotion/styled";

const ScrollContainer = styled.div`
  border: 56px solid transparent;
  border-image: url(../assets/images/pixel-scroll.png) 25% 23% repeat;

  background: #fab857;
  border-image-outset: 42px;
  margin: 112px 34px;

  image-rendering: crisp-edges;
`;

export default ScrollContainer;
